import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight, faFile } from '@fortawesome/pro-light-svg-icons'

import VideoPlayer from '@components/VideoPlayer'

import { UseCarouselPayload } from '@hooks/useCarousel'

import { AttachmentModel } from '@models/types'

import styles from './styles.module.scss'

const isRecentCacheKey = (cacheKey: number) => {
  const cacheTime = new Date(cacheKey * 1000)

  const now = new Date()
  const diffInMinutes = (now.getTime() - cacheTime.getTime()) / (1000 * 60)

  return diffInMinutes <= 2
}

interface AttachmentPreviewProps {
  attachment: AttachmentModel,
  attachmentType: string,
  carouselPayload: UseCarouselPayload,
  callbacks: {
    selectAttachment: (attachment: Partial<AttachmentModel>) => void,
  },
  roundCorners?: boolean,
}

const AttachmentPreview = (props: AttachmentPreviewProps) => {
  const {
    attachment: {
      // @ts-expect-error TS2339
      file_content_type: contentType, file_file_name, links, large_url, cache_key,
    },
    attachmentType,
    carouselPayload,
    roundCorners,
  } = props

  const {
    callbacks: { selectNext, selectPrevious },
    canSelectNext,
    canSelectPrevious,
  } = carouselPayload

  const attachmentLinks = links || {}

  // @ts-expect-error TS2345
  const imageUrl = isRecentCacheKey(cache_key) ? attachmentLinks.original_url : attachmentLinks.preserved_1120x1120

  if (attachmentType === 'image'){
    return (
      <div
        className={classnames(
          styles.root,
          styles.image,
          styles.hasNav,
          roundCorners ? styles.roundCorners : null,
        )}
      >
        {canSelectPrevious && (
        <a
          className={classnames(styles.nav, styles.left)}
          onClick={() => selectPrevious()}
          // @ts-expect-error TS2322
          tabIndex="0"
        >
          <FontAwesomeIcon className={styles.icon} icon={faAngleLeft} />
        </a>
        )}

        <img alt="Attachment Preview" src={imageUrl || large_url} style={{ width: '100%', height: 'auto' }} />

        {canSelectNext && (
        <a
          className={classnames(styles.nav, styles.right)}
          onClick={() => selectNext()}
          // @ts-expect-error TS2322
          tabIndex="0"
        >
          <FontAwesomeIcon className={styles.icon} icon={faAngleRight} />
        </a>
        )}
      </div>
    )
  }

  if (attachmentType === 'video'){
    const { original_url } = attachmentLinks

    const playerOptions = {
      autoplay: false,
      controls: true,
      sources: [
        {
          src: original_url,
          type: contentType || 'video/mp4',
        },
      ],
    }

    return (
      <div className={classnames(styles.root, styles.video)}>
        <VideoPlayer playerOptions={playerOptions} />
      </div>
    )
  }

  return (
    <div className={classnames(styles.root, styles.block)}>
      <span className={styles.unable}>Preview unavailable.</span>
      <FontAwesomeIcon className={styles.icon} icon={faFile} />
      <span className={styles.fileName}>{file_file_name}</span>
    </div>
  )
}

export default AttachmentPreview
